import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../../components/Footer.js";
import HeaderTransprent from "../../components/HeaderTransprent.js";
// import Button from "../../components/ui/Button.js";
// import ContactForm from "../../components/ui/ContactForm.js";
import { MdOutlineLocalPhone, MdMailOutline, MdOutlineHome } from "react-icons/md";

const Sectors = () => {

  // const formRef = useRef(null);
  const history = useHistory();
  // const [activeTab, setActiveTab] = useState("Corporate Law");

  const handleClick = (field) => {
    history.push(field ? `/${field}` : "/");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const handleScrollToForm = () => {
  //   formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  // };


  return (
    <>
      <div className="overflow-hidden">

        <section className="bg-cover bg-no-repeat bg-right w-full h-auto" style={{ backgroundImage: `url('/assets/home/index-hero-section.webp')`, }}>
          <HeaderTransprent />
          <div className="w-full h-full">
            <div className="flex flex-col w-full h-full py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div className="">
                <div className="flex items-center font-medium text-base text-white">
                  <MdOutlineHome size={24} className="mr-2 cursor-pointer" onClick={() => handleClick("")} />
                  <span className="mr-2 cursor-pointer" onClick={() => handleClick("expertise")}>/ Expertise</span>
                  <span>/ Ashok Gupta</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12 h-full md:py-16 py-8">
          {/* Header */}
          {/* <div className="bg-[#F7F8FA] flex flex-col md:flex-row items-center gap-6 md:p-0 p-6">
            <img src="/assets/home/ashok-gupta.webp" alt="Ashish Ambasta" className="w-64 h-64 object-cover" />
            <div>
              <h1 className="text-3xl font-semibold textblack">Ashok Gupta</h1>
              <p className="text-sm textblack mt-2">Associate, Intellectual Property Rights</p>
              <div className="flex flex-col mt-6 space-y-3 text-sm textblack">
                <div className="flex items-center gap-2">
                  <div className="flex items-center justify-center w-7 h-7 bgcolor rounded-full">
                    <MdOutlineLocalPhone className="w-4 h-4 text-white" />
                  </div>
                  <span>+91 9870503333</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex items-center justify-center w-7 h-7 bgcolor rounded-full">
                    <MdMailOutline className="w-4 h-4 text-white" />
                  </div>
                  <span>ashok@happyplus.in</span>
                </div>
              </div>
            </div>
          </div> */}

          <div className="bg-[#003366] flex flex-col md:flex-row items-center gap-6 md:p-4 p-6">
            <img src="/assets/home/ashok-gupta.webp" alt="Ashok Gupta" className="w-80 h-80 object-cover" />
            <div>
              <h1 className="md:text-4xl text-3xl font-semibold text-white">Ashok Gupta</h1>
              <p className="text-lg text-white mt-2">Managing Partner</p>
              <div className="flex flex-col mt-6 space-y-3 text-sm text-white">
                <div className="flex items-center gap-4">
                  {/* <div className="flex items-center justify-center w-7 h-7 bgcolor rounded-full"> */}
                  <MdOutlineLocalPhone className="w-6 h-6 text-white" />
                  {/* </div> */}
                  <span>+91 9870503333</span>
                </div>
                <div className="flex items-center gap-4">
                  {/* <div className="flex items-center justify-center w-7 h-7 bgcolor rounded-full"> */}
                  <MdMailOutline className="w-6 h-6 text-white" />
                  {/* </div> */}
                  <span>ashok@happyplus.in</span>
                </div>
              </div>
            </div>
          </div>


          {/* Intro */}
          <p className="textblack mt-8 text-base leading-relaxed">Ashok Gupta is a Mumbai-based partner at a leading law firm, with a strong focus on litigation, alternative dispute resolution (ADR), and employment law advisory. With significant experience representing clients across various judicial and quasi-judicial forums, Ashok is known for delivering strategic legal counsel that balances legal compliance with business realities.</p>

          <hr className="my-8 border-t-2 border-[#CB9B2D]" />

          {/* Main Grid */}
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Left: Expertise */}
            <div className="w-full space-y-6 py-8">
              <div>
                <h2 className="text-lg font-semibold textblack mb-3">EXPERTISE</h2>
                <p className="text-sm textblack">Ashok’s core strength lies in helping organizations prevent, manage, and resolve employment-related legal risks, particularly in high-regulation sectors like manufacturing, services, and banking. His work is deeply rooted in understanding the operational nuances of workplaces and aligning legal advice with HR and business needs.</p>
              </div>

              <div className="pl-5">
                <h3 className="font-semibold textblack">• Organizational Policies</h3>
                <p className="text-sm textblack mt-1 pl-4">Ashok helps companies develop and implement internal policies that comply with Indian labour laws while reflecting their corporate culture. This includes:</p>
                <ul className="list-disc text-sm textblack mt-2 pl-8">
                  <li>HR manuals and codes of conduct</li>
                  <li>POSH (Prevention of Sexual Harassment) policies</li>
                  <li>Disciplinary procedures</li>
                  <li>Remote work and hybrid work policy frameworks</li>
                </ul>
              </div>

              <div className="pl-5">
                <h3 className="font-semibold textblack">• Labour & Industrial Disputes</h3>
                <p className="text-sm textblack mt-1 pl-4">Ashok represents employers in disputes before Labour Commissioners, Industrial Tribunals, and Labour Courts. He handles:</p>
                <ul className="list-disc text-sm textblack mt-2 pl-8">
                  <li>Disciplinary actions and domestic inquiries</li>
                  <li>Union negotiations and collective bargaining</li>
                  <li>Retrenchments, layoffs, and employee exits</li>
                  <li>Conciliation, mediation, and settlement processes</li>
                </ul>
              </div>

              <div className="pl-5">
                <h3 className="font-semibold textblack">• Labour Law Compliance</h3>
                <p className="text-sm textblack mt-1 pl-4">Ashok advises clients on a wide range of statutory obligations under:</p>
                <ul className="list-disc text-sm textblack mt-2 pl-8">
                  <li>The Factories Act, Shops & Establishments Acts</li>
                  <li>Payment of Wages Act, Payment of Bonus Act, and Gratuity Act</li>
                  <li>The new Labour Codes (Wages, Social Security, Industrial Relations)</li>
                  <li>Contract labour and third-party staffing regulations</li>
                  <li>He also conducts compliance audits and due diligence for corporate transactions.</li>
                </ul>
              </div>

              <div className="">
                <p className="text-sm textblack">Ashish works closely with clients in the manufacturing, services, and banking sectors, offering industry-specific guidance that factors in operational realities. Whether it’s helping a factory update its shift policies or guiding a financial institution through employee exits during restructuring, his advice is always rooted in the law and tailored to client needs.</p>
              </div>

              <div className="">
                <p className="text-sm textblack">Ashok is regularly engaged by HR heads, business owners, and general counsel for preventive legal strategy, employee-related documentation, and support during sensitive workplace investigations. He also appears before High Courts and arbitration panels, when employment issues escalate into civil or commercial disputes.</p>
              </div>

              <div className="">
                <p className="text-sm textblack">His approach is collaborative and pragmatic—focused not just on resolving disputes, but on helping clients build legally secure and progressive workplaces. Clients appreciate Ashok’s attention to detail, responsiveness, and ability to translate complex legal frameworks into clear, actionable steps.</p>
              </div>
            </div>

            {/* Right: Practice Areas */}
            {/* <div className="space-y-6 lg:w-1/3 bg-[#F7F8FA] p-6 h-full">
              <div>
                <h2 className="text-lg font-semibold textblack mb-2">PRACTICE AREAS</h2>
                <ul className="list-disc list-inside text-sm textblack space-y-1">
                  <li>Antitrust And Competition Law</li>
                  <li>Capital Markets: India & Intl.</li>
                  <li>Family Business</li>
                  <li>Employment Law</li>
                  <li>Corporate Law</li>
                </ul>
              </div>
              <hr className="my-12 border-t-2 border-[#CB9B2D]" />
              <div>
                <h2 className="text-lg font-semibold textblack mb-2">SECTORS</h2>
                <ul className="list-disc list-inside text-sm textblack space-y-1">
                  <li>Antitrust And Competition Law</li>
                  <li>Capital Markets: India & Intl.</li>
                  <li>Family Business</li>
                  <li>Corporate Law</li>
                </ul>
              </div>
            </div> */}
          </div>
        </div>


        {/* <section ref={formRef} className="bg-cover bg-no-repeat md:py-16 py-8 bg-[#F7F8FA]">
          <div className="flex flex-col justify-start w-full h-full 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="mx-auto px-4 w-full">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/2 flex flex-col justify-center md:mb-0 pr-0 md:pr-10 md:pt-0 pt-4">
                  <div className="flex items-center justify-center w-full">
                    <img src="/assets/home/contact-us.webp" alt="Lead with Clarity" className="z-0" />
                  </div>
                </div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section> */}

        <Footer />
      </div>
    </>
  );
};


export default Sectors;
